export enum PageType {
    EndPage = 'endPage',
    Page = 'page',
}

export default PageType;
